import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import "./Logistics.css";

function Logistics() {
  return (
    <section className="logistics section">
      <div className="container">
        <SectionTitle
          center
          eyebrow="Logística"
          title="Entrega rápida e pronta para abastecer seu restaurante"
        />

        <div className="logistics__grid">
          <div>
            <h3>Prazo de entrega</h3>
            <p>3 dias úteis após confirmação do pagamento</p>
          </div>

          <div>
            <h3>Pedido mínimo</h3>
            <p>10kg (Frozen) ou 5 caixas de 10L (sorvetes)</p>
          </div>

          <div>
            <h3>Validade</h3>
            <p>Até 12 meses congelado</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Logistics;